export const URL_SEARCH_PARAM = {
  backUrl: 'backUrl',
}
